var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "md-layout md-gutter md-alignment-top-center" }, [
      _c(
        "div",
        {
          staticClass:
            "md-layout-item md-size-15 md-medium-size-10 md-small-size-100 md-xsmall-size-100"
        },
        [
          _c(
            "md-button",
            {
              staticClass: "md-fab",
              on: {
                click: function($event) {
                  return _vm.goBack()
                }
              }
            },
            [_c("md-icon", [_vm._v("arrow_back")])],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "md-layout-item md-size-70 md-medium-size-80 md-small-size-100 md-xsmall-size-100"
        },
        [
          _c(
            "md-card",
            { staticStyle: { width: "100%" } },
            [
              _c("md-card-header", [
                _c(
                  "div",
                  { staticClass: "md-title", attrs: { align: "center" } },
                  [
                    _vm._v(
                      "\n            Geschäftsmodell-Konfigurator\n          "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("md-card-content", { attrs: { align: "center" } }, [
                _c(
                  "div",
                  { staticClass: "md-layout md-gutter md-alignment-center" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "md-layout-item md-size-100",
                        attrs: { align: "center" }
                      },
                      [
                        _c(
                          "md-button",
                          {
                            staticClass: "md-primary",
                            on: {
                              click: function($event) {
                                _vm.nameActive = true
                              }
                            }
                          },
                          [_vm._v("Neues Geschäftsmodell erstellen")]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "md-layout-item md-size-100",
                        attrs: { align: "center" }
                      },
                      [
                        _c(
                          "router-link",
                          { attrs: { to: { name: "BMLoad" } } },
                          [
                            _c("md-button", { staticClass: "md-primary" }, [
                              _vm._v("Ihre Geschäftsmodelle")
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "md-layout-item md-size-100",
                        attrs: { align: "center" }
                      },
                      [
                        _c(
                          "router-link",
                          { attrs: { to: { name: "BMExample" } } },
                          [
                            _c("md-button", { staticClass: "md-primary" }, [
                              _vm._v("Muster/Beispiel-Geschäftsmodelle ansehen")
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "md-layout-item md-size-100",
                        attrs: { align: "center" }
                      },
                      [
                        _c("video", { attrs: { controls: "" } }, [
                          _c("source", {
                            attrs: { src: "/static/bmc.mp4", type: "video/mp4" }
                          }),
                          _vm._v(
                            "\n                Ihr Browser unterstützt die Wiedergabe dieses Videos nicht.\n                Bitte wechseln Sie zu einem Browser mit HTML5-Support.\n              "
                          )
                        ])
                      ]
                    )
                  ]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "md-dialog",
            {
              attrs: { "md-active": _vm.nameActive },
              on: {
                "update:mdActive": function($event) {
                  _vm.nameActive = $event
                },
                "update:md-active": function($event) {
                  _vm.nameActive = $event
                }
              }
            },
            [
              _c(
                "div",
                { staticStyle: { padding: "10px" } },
                [
                  _c("md-dialog-title", [
                    _vm._v("Name für das Geschäftsmodell")
                  ]),
                  _vm._v(" "),
                  _c(
                    "md-field",
                    [
                      _c("label", { attrs: { for: "name" } }, [_vm._v("Name")]),
                      _vm._v(" "),
                      _c("md-input", {
                        attrs: { name: "name", id: "name" },
                        model: {
                          value: _vm.nameValue,
                          callback: function($$v) {
                            _vm.nameValue = $$v
                          },
                          expression: "nameValue"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "md-dialog-actions",
                    [
                      _c(
                        "md-button",
                        {
                          staticClass: "md-primary",
                          on: {
                            click: function($event) {
                              _vm.nameActive = false
                            }
                          }
                        },
                        [_vm._v("Abbrechen")]
                      ),
                      _vm._v(" "),
                      _c(
                        "md-button",
                        {
                          staticClass: "md-primary",
                          on: {
                            click: function($event) {
                              _vm.createNew()
                              _vm.nameActive = false
                            }
                          }
                        },
                        [_vm._v("Fertig")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", {
        staticClass:
          "md-layout-item md-size-15 md-medium-size-10 md-small-size-100 md-xsmall-size-100"
      })
    ]),
    _vm._v(" "),
    _vm._m(0)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "md-layout md-gutter md-alignment-center",
        staticStyle: { "margin-top": "50px", "margin-bottom": "30px" }
      },
      [
        _c("div", {
          staticClass:
            "md-layout-item md-size-15 md-medium-size-10 md-small-size-0 md-xsmall-size-0"
        }),
        _vm._v(" "),
        _c("div", {
          staticClass: "md-layout-item md-size-70 md-medium-size-80"
        }),
        _vm._v(" "),
        _c("div", {
          staticClass:
            "md-layout-item md-size-15 md-medium-size-10 md-small-size-0 md-xsmall-size-0"
        })
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-44514d62", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44514d62","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/company/businessmodel/menu/BMMenu.vue
// module id = null
// module chunks = 